import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Waypoint from 'react-waypoint';
import Raven from 'raven-js';
import { Scrollbars } from 'react-custom-scrollbars';

import Users from 'api/resources/users';
import getErrors from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import PaymentRow from 'admin-moderator/components/PaymentRow';

import Loader from 'components/Loader';

import ErrorText from 'styled/Page/ErrorText';
import CenteredContainer from 'styled/Page/CenteredContainer';
import Header from 'styled/Page/Header';
import HeaderTitle from 'styled/Page/HeaderTitle';

const PAGE_SIZE = 20;

export class UserTransactionsPage extends React.PureComponent {
  state = {
    transactions: [],
    loading: false,
    errors: [],
    hasMore: false,
    pageNumber: 0,
  }

  componentDidMount() {
    this.loadTransactions();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.match.params.userId !== prevProps.match.params.userId)
      || (this.props.shouldTransactionsUpdate && this.props.shouldTransactionsUpdate !== prevProps.shouldTransactionsUpdate)
    ) {
      this.reloadTransactions();
    }
  }

  reloadTransactions = () => {
    this.setState({
      transactions: [],
      pageNumber: 0,
    }, this.loadTransactions);
  }

  loadTransactions = async () => {
    this.setState({ loading: true, errors: [] });

    try {
      const response = await Users.getTransactionsHistory({
        userId: this.props.match.params.userId,
        page: {
          size: PAGE_SIZE,
          number: this.state.pageNumber,
        },
        include: 'transaction_record',
      });

      const transactions = await new Deserializer({
        keyForAttribute: 'camelCase',
        withdraw: {
          valueForRelationship: (relationship, included) => ({
            ...included,
            type: relationship.type,
          }),
        },
        task_material_reward: {
          valueForRelationship: (relationship, included) => ({
            ...included,
            type: relationship.type,
          }),
        },
        reward: {
          valueForRelationship: (relationship, included) => ({
            ...included,
            type: relationship.type,
          }),
        },
      }).deserialize(response);

      this.setState(prevState => ({
        transactions: prevState.transactions.concat(transactions),
        loading: false,
        hasMore: transactions.length === PAGE_SIZE,
        pageNumber: prevState.pageNumber + 1,
      }));
      this.props.onTransactionsUpdate();
    } catch (err) {
      this.setState({ errors: await getErrors(err), loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <Scrollbars autoHeight autoHeightMax="calc(100vh - 105px)">
        <div style={{ padding: '0 24px' }}>
          <Header style={{ margin: 0, minHeight: 'auto' }}>
            <HeaderTitle>История платежей</HeaderTitle>
          </Header>

          {this.state.transactions.map(transaction => (
            <PaymentRow
              key={transaction.id}
              id={transaction.id}
              type={transaction.transactionRecord && transaction.transactionRecord.type}
              status={transaction.transactionRecord && transaction.transactionRecord.status}
              errorCode={transaction.transactionRecord && transaction.transactionRecord.errorCode}
              date={transaction.createdAt}
              comment={transaction.transactionRecord && transaction.transactionRecord.comment}
              amount={transaction.transactionRecord ? (transaction.transactionRecord.amount || '0') : '0'}
              method={transaction.transactionRecord && transaction.transactionRecord.method}
              methodInfo={transaction.transactionRecord && transaction.transactionRecord.methodInfo}
            />
          ))}

          {!this.state.loading && !this.state.errors.length && this.state.hasMore && (
            <Waypoint onEnter={this.loadTransactions} />
          )}

          {this.state.loading && (
            <CenteredContainer><Loader /></CenteredContainer>
          )}

          {this.state.transactions.length === 0
            && !this.state.loading
            && this.state.errors.length === 0 && (
            <CenteredContainer><ErrorText>Нет истории платежей</ErrorText></CenteredContainer>
          )}

          {this.state.errors.length > 0 && (
            <CenteredContainer>
              {this.state.errors.map(error => (
                <ErrorText role="alert" key={error}>{error}</ErrorText>
              ))}
            </CenteredContainer>
          )}
        </div>
      </Scrollbars>
    );
  }
}

UserTransactionsPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  shouldTransactionsUpdate: PropTypes.bool,
  onTransactionsUpdate: PropTypes.func,
};

UserTransactionsPage.defaultProps = {
  shouldTransactionsUpdate: false,
  onTransactionsUpdate: () => {},
};

export default withRouter(UserTransactionsPage);
